import { apiGet } from 'api';
import { GetFilterTypesResponse } from '../../types';

export const getFilterConsultationTypes = (): Promise<GetFilterTypesResponse> =>
  apiGet<GetFilterTypesResponse>('consultationtypes');
